import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const isWESCoachV2Enabled = () => EnterpriseExperiments.get('enableWESCoachV2');
